if (!customElements.get('concours-new-carousel')) {
  customElements.define(
    'concours-new-carousel',
    class ConcoursNewCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        this.querySelectorAll('[data-step]').forEach((button) => {
          button.addEventListener('click', () => this.move(Number(button.dataset.step)));
        });
      }

      get slideCount() {
        return this.track.children.length;
      }

      get currentIndex() {
        return Math.round(this.track.scrollLeft / this.track.clientWidth);
      }

      move(step) {
        const next = (this.currentIndex + step + this.slideCount) % this.slideCount;
        this.track.scrollTo({ left: next * this.track.clientWidth });
      }
    }
  );
}
